import React from "react";

import Link from "./base/link";

import { useContentContext } from "../context/content-context";

const SecondaryNavLinks = () => {
  const { secondaryMenuItems, isHCP, language } = useContentContext();

  return (
    <>
      {secondaryMenuItems.map(({ post_title, url }) => (
        <Link
          href={url}
          key={url}
          target="_blank"
          variant={
            isHCP
              ? "hcpSubnav"
              : language === "esp"
              ? "patientSubnavEsp"
              : "patientSubnav"
          }
        >
          {post_title}
        </Link>
      ))}
    </>
  );
};

export default SecondaryNavLinks;
